import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { ListItem, DropdownMenu } from '../../../../../components/generic'
import RiskValue from '../../../../../components/carePlans/RiskValue'
import { RISK_LEVELS } from '../../../../../common/constants'
import { colors } from '@lmc/common/constants'
import CarePlansPopup from '../../../../../components/carePlans/CarePlansPopup'
import FuturePlansPopup from './FuturePlansPopup'

export default class RiskAssessmentItem extends React.Component {
  formatDate = (date) => dayjs(date).format('DD-MM-YYYY • HH:mm')

  getSubLabel = () => {
    const { carer, riskAssessment, showUpdateAlert } = this.props

    const name = `${carer?.name?.first || ''} ${carer?.name?.last || ''}`
    const date =
      riskAssessment.incomplete || showUpdateAlert
        ? this.formatDate(riskAssessment.createdOn)
        : this.formatDate(riskAssessment.reviewedOn || riskAssessment.createdOn)

    if (riskAssessment.incomplete) {
      return (
        <span>
          Incomplete • {date} • {name}
        </span>
      )
    }
    if (showUpdateAlert) {
      return (
        <span>
          Updated since last review • {date} • {name}
        </span>
      )
    }
    return (
      <span>
        Reviewed {date} • {name}
      </span>
    )
  }

  renderRisk = (riskAssessment) => (
    <div
      style={{
        ...styles.flexContainer,
        ...styles.riskContainer,
      }}
    >
      {riskAssessment.riskLevel && (
        <span style={styles.riskLevel}>
          {RISK_LEVELS[riskAssessment.riskLevel]}
        </span>
      )}
      {riskAssessment.riskLevel && (
        <RiskValue
          risk={riskAssessment.riskLevel}
          value={riskAssessment.riskScore}
        />
      )}
    </div>
  )

  renderDropdownMenu = () => {
    const { onDelete, onEdit, riskAssessment } = this.props
    return (
      <DropdownMenu
        buttonStyle={styles.flexContainer}
        items={[
          {
            label: 'Edit',
            onClick: () => onEdit(riskAssessment),
          },
          {
            label: 'Remove',
            onClick: () => onDelete(riskAssessment.id),
          },
        ]}
        menuStyle={styles.menuContainer}
      />
    )
  }

  render() {
    const {
      onEdit,
      onView,
      showUpdateAlert,
      riskAssessment,
      carePlanNominative,
      allowRedirect = true,
      isRiskAssessmentFuturePlanEnabled = false
    } = this.props

    if (!riskAssessment || !riskAssessment.form) return null
    const showRiskAssessmentCarePlansPopup = !!riskAssessment?.carePlans?.length
    const showRiskAssessmentFuturePlansPopup =
      isRiskAssessmentFuturePlanEnabled &&
      !!riskAssessment?.contingencyPlans?.length
    const showAttachments =
      showRiskAssessmentCarePlansPopup || showRiskAssessmentFuturePlansPopup

    return (
      <ListItem
        hasBorder
        iconText={riskAssessment.form.iconText}
        iconColor={riskAssessment.form.color}
        label={riskAssessment.form.name}
        multiSelect
        onSelect={() => {
          onEdit ? onEdit(riskAssessment) : onView(riskAssessment.id)
        }}
        subLabel={this.getSubLabel()}
        subLabelAlert={riskAssessment.incomplete || showUpdateAlert}
        iconSize={20}
        size={40}
        subLabelChildren={
          showAttachments ? (
            <>
              {showRiskAssessmentCarePlansPopup && (
                <CarePlansPopup
                  riskAssessmentCarePlans={riskAssessment?.carePlans}
                  carePlanNominative={carePlanNominative}
                  allowRedirect={allowRedirect}
                />
              )}
              {showRiskAssessmentFuturePlansPopup && (
                <FuturePlansPopup
                  contingencyPlans={riskAssessment.contingencyPlans}
                  residentId={riskAssessment?.resident}
                  allowRedirect={allowRedirect}
                />
              )}
            </>
          ) : null
        }
      >
        <div
          style={{
            ...styles.flexContainer,
            ...styles.childContainer,
          }}
        >
          {this.renderRisk(riskAssessment)}
          {onEdit && this.renderDropdownMenu()}
        </div>
      </ListItem>
    )
  }
}

const styles = {
  childContainer: {
    justifyContent: 'flex-end',
    position: 'relative',
  },
  flexContainer: {
    alignItems: 'center',
    // paddingTop: 4,
    display: 'flex',
  },
  menuContainer: {
    position: 'absolute',
    top: 25,
    right: '-13px',
  },
  riskContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  riskLevel: {
    color: colors.darkgrey,
    display: 'block',
    fontSize: 11,
    marginRight: 12,
  },
  riskScore: {
    color: 'white',
    fontSize: 13,
    fontWeight: 'bold',
  },
}

RiskAssessmentItem.propTypes = {
  carer: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
  riskAssessment: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  showUpdateAlert: PropTypes.bool,
  allowRedirect: PropTypes.bool,
  isRiskAssessmentFuturePlanEnabled: PropTypes.bool
}
